// This object contains the translated event names. Please use them in the rest of the app.
const AlbazeaEvents = {
    ContractCreated: "AlbazeaContractCreated",
    ContractTerminated: "AlbazeaContractExecuted",
    ContractProcessed: "AlbazeaContractExecuted",
    ContractFaithOfLifeRefreshed: "AlbazeaContractFaithOfLifeRefreshed"
}

export {AlbazeaEvents};